import { useCallback } from 'react';
import { View } from 'react-native';
import { Text } from '@/components/Text';
import { styles } from './styles';
import { PressableNeolexon } from '@/components/PressableNeolexon';

export function Tab({ tabName, id, keyName, isActive, onPress }) {
  const setTabActive = useCallback(() => {
    if (isActive) return;
    onPress({ id, tabName, keyName });
  }, [isActive]);

  return (
    <View style={[styles.tabContainer, isActive && styles.isTabActive]}>
      <PressableNeolexon style={styles.tab} onPress={setTabActive}>
        <Text style={[styles.tabText, isActive && styles.isTabActiveText]}>
          {tabName}
        </Text>
      </PressableNeolexon>
    </View>
  );
}
